import * as React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Card, CardContent, Paper, Typography } from "@mui/material";
import { FixedSizeList as List } from "react-window";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import Tooltip from "@mui/material/Tooltip";
interface Props {
  cases: any[];
  height: number | string;
  searchTerm: string;
}

const ThriveActivitySelection: React.FC<Props> = ({
  cases,
  height,
  searchTerm,
}: Props) => {
  const [currentCases, setCurrentCases] = React.useState<any[]>(cases);
  const [loadingFlag, setLoadingFlag] = React.useState<boolean>(true);

  // Sync currentCases and originalCases with cases prop when it changes, unless loading or search is active
  React.useEffect(() => {
    setCurrentCases(cases);
    setLoadingFlag(false);
  }, [cases]);

  const Row: React.FC<{ index: number; style: React.CSSProperties }> = ({
    index,
    style,
  }) => {
    return (
      <Tooltip
        title={currentCases[index]["activity_note"] || ""}
        placement="right"
      >
        {currentCases[index]["firmRecord"] && (
          <ListItem key={index} disablePadding sx={style}>
            <ListItemButton>
              <Link
                style={{ width: "100%" }}
                to={`/case?id=${currentCases[index]["caseRecord"]["_id"]}&activity=${currentCases[index]["_id"]}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // margin: "10px",
                    marginBottom: "5px",
                    padding: "0 0 0 5px",
                    textAlign: "left",
                    overflow: "auto",
                    whiteSpace: "nowrap",
                  }}
                  // onClick={() => setOpen(true)}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <CardContent sx={{ flex: "1 0 auto" }}>
                      <Typography component="div" variant="h5">
                        {currentCases[index]["firmRecord"]["Company Name"]}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        component="div"
                        sx={{ fontWeight: "bold" }}
                      >
                        Contact: {currentCases[index]["firmRecord"]["Contact"]}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        component="div"
                      >
                        Activity Date:{" "}
                        {dayjs(currentCases[index]["interaction_date"]).format(
                          "MM/DD/YYYY"
                        )}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        component="div"
                      >
                        Activity Type: {currentCases[index]["activity_type"]}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        component="div"
                      >
                        {(() => {
                          const note =
                            currentCases[index]["activity_note"] || "";
                          if (!searchTerm || !note)
                            return `Activity Note: ${note}`;
                          const regex = new RegExp(
                            `(\\b(?:\\w+\\W+){0,5})(${searchTerm})(\\W+(?:\\w+\\W+){0,5})`,
                            "i"
                          );
                          const match = note.match(regex);
                          if (!match) return `Activity Note: ${note}`;
                          const before = match[1] || "";
                          const found = match[2] || "";
                          const after = match[3] || "";
                          return (
                            <>
                              Activity Note: ...{before}
                              <span style={{ backgroundColor: "yellow" }}>
                                {found}
                              </span>
                              {after}...
                            </>
                          );
                        })()}
                      </Typography>
                    </CardContent>
                  </Box>
                </Card>
              </Link>
            </ListItemButton>
          </ListItem>
        )}
      </Tooltip>
    );
  };

  // console.log("Current Cases: ", currentCases);
  // console.log("Available Users: ", availableUsers);
  return (
    <>
      {loadingFlag ? (
        <Paper sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Paper>
      ) : (
        <>
          {currentCases.length === 0 ? (
            <Paper sx={{ width: "100%", textAlign: "center", height: "80%" }}>
              <Typography>No Matching Activity</Typography>
            </Paper>
          ) : (
            <List
              height={height}
              width={"100%"}
              itemCount={currentCases.length}
              itemSize={180} // height of each item
            >
              {Row}
            </List>
          )}
        </>
      )}
    </>
  );
};

export default ThriveActivitySelection;
